export const EMPLOYEE_CENTER = {
  TITLE: 'Centro de Empleados',
  BACK_TO_HOME: 'Volver',
  TOOLS: {
    TITLE: 'Herramientas',
    PASSWORD_MANAGER: 'Gestor de Contraseñas',
    BROWSER_EXTENSION: 'Extensión del Navegador',
    EDR_AGENT: 'Agente EDR',
    MDM_MOBILE: 'MDM Móvil',
    MDM_DIALOG: {
      TITLE: 'Activar MDM',
      DESCRIPTION: 'Registra tu teléfono en la gestión de dispositivos móviles',
      SELECT_PLATFORM: 'Selecciona tu plataforma',
      PLATFORMS: {
        IOS: 'iOS',
        ANDROID: 'Android',
      },
      IOS_UNAVAILABLE: 'Tu equipo de TI configura los iPhone de empresa',
      STEPS: {
        SCAN_QR: 'Escanea para abrir la página de registro',
        SET_UP_WORK_PROFILE: 'Selecciona «Enroll» y sigue los pasos para crear tu perfil de trabajo',
        CHECK_WORK_APPS: 'Tus apps de trabajo muestran ahora un icono de maletín',
      },
    },
  },
  DOCUMENTATION: {
    TITLE: 'Documentación',
    PASSWORD_MANAGER_HANDBOOK: 'Manual del Gestor de Contraseñas',
    INSTALLING_AGENT: 'Instalando el Agente',
    INSTALLING_CHROME_EXTENSION: 'Instalación de Extensión de Google Chrome',
    INSTALLING_MDM_MOBILE: 'Instalación de MDM Móvil',
  },
  POLICIES: {
    TITLE: 'Políticas',
    SEARCH_PLACEHOLDER: 'Buscar políticas',
    SIGN_ALL_POLICIES: 'Firmar Todas las Políticas',
    READ_POLICY: 'Leer política',
    SIGNED_MESSAGE: 'Has firmado todas las políticas el',
    CLOSE: 'Cerrar',
    ERROR_LOADING_POLICY: 'Error al cargar política',
    LOADING: 'Cargando…',
    NO_CONTENT_AVAILABLE: 'No hay contenido disponible',
    POLICY_NOT_AVAILABLE: 'Política no disponible',
    CUSTOM_FILES: 'Archivos Personalizados',
    CUSTOM_LINKS: 'Enlaces Personalizados',
    SIGN: 'Firmar',
    ATTESTATION: 'He leído y acepto esta política',
    STATUS_SIGNED: 'Firmada',
    STATUS_UNSIGNED: 'Sin firmar',
    STATUS_OUTDATED: 'Volver a firmar',
    STATUS_OUTDATED_ADMIN: 'Desactualizada',
    OF: 'de',
    SIGNED_COUNT_LABEL: 'firmadas',
  },
  ERRORS: {
    LOADING_EMPLOYEE_DATA: 'Error al cargar datos del empleado',
  },
  FOREIGN_ORGANIZATION: {
    TITLE: 'Aquí no hay nada que mostrar',
    DESCRIPTION:
      'El Centro de Empleados muestra tus propias políticas y herramientas. Estás viendo {organization} como administrador, así que aquí no tienes ninguna.',
    HINT: 'Para revisar a un empleado, abre el dashboard de empleados y selecciónalo para ver sus detalles y políticas.',
    OPEN_DASHBOARD: 'Abrir el dashboard de empleados',
    GO_BACK: 'Volver',
  },
}
